module.exports = __webpack_public_path__ + "static/wagger-bc70146d3ff8f66b33dcab9175575b3e.jpg";